<formly-field [field]="getField()"></formly-field>